import { Grid } from "@mui/material";
import { observer } from "mobx-react";
import React from "react";
import { IAcxHierarchyComponentProps } from "./AcxHierarchySelector";
import AcxButton from "../AcxButton";

const HierarchySelectorFooter: React.FC<IAcxHierarchyComponentProps> = observer(
    (props: IAcxHierarchyComponentProps) => {
        const isOverSelectionLimit =
            !!props.maxSelectedHierarchyCount &&
            props.treeStore.selectedBranchIds.length >
                props.maxSelectedHierarchyCount;

        return (
            <Grid
                container
                justifyContent="flex-end"
                sx={(theme) => ({
                    padding: "24px",
                    minHeight: "78px",
                    borderTop: `1px solid ${theme.palette.gray[200]}`,
                    backgroundColor: theme.palette.white.main,
                })}
            >
                <Grid
                    item
                    container
                    wrap="nowrap"
                    columnGap={1}
                    justifyContent="flex-end"
                    sx={{ paddingLeft: "25%" }}
                >
                    <Grid item>
                        <AcxButton
                            tooltip="Reset selection"
                            color="white"
                            onClick={() => {
                                props.treeStore.clearSelectedBranchIds();
                            }}
                            fullWidth={false}
                        >
                            Clear
                        </AcxButton>
                    </Grid>
                    <Grid item>
                        <AcxButton
                            tooltip={"Save to apply"}
                            color="primary"
                            onClick={props.onApplyClick}
                            disabled={isOverSelectionLimit}
                            disabledTooltip={props.selectionLimitMessage}
                        >
                            {props?.applyBtnText ?? "Apply Hierarchies"}
                        </AcxButton>
                    </Grid>
                </Grid>
            </Grid>
        );
    },
);

export default HierarchySelectorFooter;
